import React, {Component} from 'react';
import {  Switch, Link, Route } from 'react-router-dom';
import QualityContent from '../components/QualityContent'; 
 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import { Helmet } from "react-helmet";
import { base_url} from '../common/Constants';
 
class Quality extends React.Component{
 
    render()
    {
        const content = JSON.parse(localStorage.getItem("content"));
        const metas = JSON.parse(localStorage.getItem("metas"));
        return (
            <div className="page-wrapper">
                <Header/> 
                <Helmet>
                    <title>{metas[2].title}</title>  
                    <meta name="description" content={metas[2].meta_description} />
                    <meta name="keywords" content={metas[2].meta_title} />
                    <meta property="og:image" content={content[7].image}  />
                    <link rel="canonical" href={base_url+'quality-policy'} />
                </Helmet>
                <PageHeader title="Quality Policy"/>
                <QualityContent content={JSON.parse(localStorage.getItem("content"))} certificates={JSON.parse(localStorage.getItem("certificates"))} />  
                <Footer/>
            </div>
       
        )
    }

}
export default Quality;